module.exports = __webpack_public_path__ + "static/Juan-Rincon-df74196b87cdc53d7803dd0f1cefed4b.png";